import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import isPublicView from "app/utils/publicViewUtils";
import { FormattedMessage } from "react-intl";
import "./Stake.scss";

type Props = {
  maxStake: number;
  handleMaxClick: (value: number) => void;
};

const MaxStake: React.FC<Props> = ({ handleMaxClick, maxStake }) => {
  return (
    <div>
      {isPublicView() ? (
        <div className="max-stake">&nbsp;</div>
      ) : (
        <div
          className="max-stake"
          onClick={() => maxStake > 0 && handleMaxClick(maxStake)}
        >
          <FormattedMessage tagName="span" id="events-graphmaxstake" />
          {":"}
          <CurrencyNumber
            className={"max-stake__profit"}
            value={maxStake || 0}
            minimumFractionDigits={0}
          />
        </div>
      )}
    </div>
  );
};

export default MaxStake;
